import React, { useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.min.css";
import { FaCalendar } from "react-icons/fa";
// import "./DateInput.css"; // Custom styles

const DateInput = ({ label, value, onChange, required = false, min }) => {
  const datepickerRef = useRef(null);

  const handleInputClick = () => {
    if (datepickerRef.current) {
      if (datepickerRef.current.input) {
        datepickerRef.current.input.blur();
      } else {
        document.activeElement.blur();
      }
    } else {
      document.activeElement.blur();
    }
  };

  return (
    <div>
      <label className="form-label text-white fontSize14Regular mb-2">
        {label}
        {required && "*"}
      </label>

      <div className="position-relative custom-datepicker-wrapper">
        <DatePicker
          ref={datepickerRef}
          isClearable={value}
          className="form-control bg-transparent text-white borderRadius10 border px-5 custom-datepicker-padding"
          selected={value}
          onChange={onChange}
          disabledKeyboardNavigation
          minDate={min}
          dateFormat="dd/MM/yyyy"
          placeholderText=""
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          onKeyDown={(e) => e.preventDefault()}
          onInputClick={handleInputClick}
        />
        <span className="calendar-icon">
          <FaCalendar />
        </span>
      </div>
    </div>
  );
};

export default DateInput;
